import { styled } from "@mui/material";

export const Value = styled("span")({
  fontFamily: "'IBM Plex Mono'",
  fontWeight: 500,
});

export const Units = styled("span")(({ theme }) => ({
  color: theme.palette.grey[600],
  fontFamily: "'IBM Plex Mono'",
  fontSize: theme.spacing(1.25),
  fontWeight: 400,
}));
